// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.container[data-v-71ab9963] {\n\tmargin-left: 0 !important;\n}\n.price-edit-container[data-v-71ab9963] {\n\tpadding-top: 0;\n\tmargin: 0;\n}\n\n", ""]);
// Exports
module.exports = exports;
